import axios, { AxiosInstance } from "axios";
import {
  CarService,
  CarWidgetInfo,
  DeliveryOptions,
  FormContactCar,
  FormErrorType,
} from "../types/widget-types";
import { extractUrlOfCustomer } from "../utils/parser-url";

export class ApiClient {
  static shared = new ApiClient();
  constructor(private client: AxiosInstance = axios) {
    client.interceptors.request.use(async (config) => {
      config.headers = {
        Accept: "application/ld+json",
        "Content-Type": "application/ld+json",
        ...config.headers,
      };
      if (process.env["REACT_APP_AUTH_TOKEN"]) {
        config.headers["X-AUTH-TOKEN"] = process.env["REACT_APP_AUTH_TOKEN"];
      }
      if (process.env["REACT_APP_ACCOUNT_TOKEN"]) {
        config.headers["X-CarWidgetApiToken"] =
          process.env["REACT_APP_ACCOUNT_TOKEN"];
      }
      config.baseURL = process.env["REACT_APP_API_HOST"];
      return config;
    });
  }
  searchRegisterNumber = (number: string) => {
    return this.client
      .get<CarWidgetInfo>(`/api/widget/car_info/${number}`)
      .then((res) => res.data);
  };

  getServices = () => {
    return this.client
      .get(`/api/widget/car_services`)
      .then<CarService[]>((res) => res.data);
  };

  getDeliveryOptions = () => {
    return this.client
      .get(`/api/widget/delivery_options`)
      .then<DeliveryOptions[]>((res) => res.data);
  };

  validateContactForm = <ErrorResponse extends {}>(body: object) => {
    return this.client
      .post<(ErrorResponse | string)>(
        "/api/widget/validate_contacts",
        body
      ).then(res=> res.data)
      .catch((e) => {
        const arrayValidation = e.response.data
          .violations as FormErrorType<FormContactCar>[];
        return arrayValidation.reduce(
          (acc, item) => ({
            ...acc,
            [item.propertyPath]: item.message,
          }),
          {} as FormContactCar
        );
      });
  };

  makeOrder = (body: object) => {
    const customerInfo = { customerMarketingInfo: extractUrlOfCustomer() };
    return this.client
      .post("/api/widget/order", { ...body, ...customerInfo })
      .then<{ leadId: string }>((res) => res.data);
  };

  contactWithManager = (body: object) => {
    return this.client.post("/api/widget/order", body).then((res) => res.data);
  };
}
